import React, { useState, useEffect, useCallback } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import useVoucherDistribution from '../../hooks/useVoucherDistribution'; // <-- USA L'HOOK CORRETTO
import { Table, Card, Form, Alert, Spinner, Accordion, Badge, Button } from 'react-bootstrap';
import { alertService } from '../../services/AlertService';
import { useSelector } from 'react-redux';
import UtilityService from '../../services/UtillityServices/UtilityService';

export default function DistribuzioneVoucherSP({ show, onHide, selectedAgenzia }) {
        
    const userLoggedIn = useSelector(state => state.user.userData);
    
    // --- Hook e Funzioni Corrette ---
    const { isLoading: isDistributing, distributeVoucher, getHistoryForAgenzia  } = useVoucherDistribution();
    // NOTA: La funzione per leggere il magazzino la sposteremo nell'hook dedicato per pulizia.
    // Per ora la lasciamo qui per testare, poi la sposteremo.
    const { getMagazzino, loadingStateVoucher } = useVoucherDistribution(); 

    const [isLoading, setIsLoading] = useState(false);
    const [groupedVouchers, setGroupedVouchers] = useState({});
    const [showDistributeForm, setShowDistributeForm] = useState(false);
    const [selectedMasterVoucher, setSelectedMasterVoucher] = useState(null);
    const [distributionFormData, setDistributionFormData] = useState({ quantita_da_distribuire: '', note: '' });
    const [viewMode, setViewMode] = useState('history'); // 'history' o 'distribute'
    const [history, setHistory] = useState([]);

    const loadSuperpartnerVouchers = useCallback(async () => {
        if (!show) return;

        setIsLoading(true);
        try {
            // --- CHIAMATA ALLA FUNZIONE CORRETTA ---
            // Questa funzione chiama l'endpoint /voucher-distribution/get-magazzino
            const masterPacks = await getMagazzino(selectedAgenzia.id_superpartner);
            
            const grouped = (Array.isArray(masterPacks) ? masterPacks : []).reduce((acc, voucher) => {
                const courseId = voucher.id_corso;
                if (!acc[courseId]) { acc[courseId] = { nome_corso: voucher.nome_corso, pacchetti: [], totale_rimanente: 0 }; }
                
                const rimanente = parseInt(voucher.qt_disponibile) || 0;
                voucher.rimanente = rimanente;
                acc[courseId].pacchetti.push(voucher);
                if (rimanente > 0) {
                    acc[courseId].totale_rimanente += rimanente;
                }
                return acc;
            }, {});
            setGroupedVouchers(grouped);
        } catch (error) {
            alertService.error("Errore nel caricamento dei pacchetti voucher.");
        } finally {
            setIsLoading(false);
        }
    }, [show, getMagazzino]);

    useEffect(() => {
        const loadHistory = async () => {
            if (show && selectedAgenzia?.id_agenzia) {
                setIsLoading(true);
                const historyData = await getHistoryForAgenzia(selectedAgenzia.id_agenzia);
                setHistory(historyData || []);
                setIsLoading(false);
            }
        };
        loadHistory();
    }, [show, selectedAgenzia]);
    
    const handleSwitchToDistributeView = async () => {
        setIsLoading(true);
        const masterPacks = await getMagazzino(userLoggedIn.id_superpartner);
        
        const grouped = (Array.isArray(masterPacks) ? masterPacks : []).reduce((acc, voucher) => {
            const courseId = voucher.id_corso;
            if (!acc[courseId]) { acc[courseId] = { nome_corso: voucher.nome_corso, pacchetti: [], totale_rimanente: 0 }; }
            
            const rimanente = parseInt(voucher.qt_disponibile) || 0;
            voucher.rimanente = rimanente;
            acc[courseId].pacchetti.push(voucher);
            if (rimanente > 0) {
                acc[courseId].totale_rimanente += rimanente;
            }
            return acc;
        }, {});
        setGroupedVouchers(grouped);
        setViewMode('distribute');
        setIsLoading(false);
    };

    const handleOpenDistributeForm = (voucher) => {
        setSelectedMasterVoucher(voucher);
        setShowDistributeForm(true);
    };

    const handleCloseDistributeForm = () => {
        setShowDistributeForm(false);
        setSelectedMasterVoucher(null);
        setDistributionFormData({ quantita_da_distribuire: '', note: '' });
    };

    const handleDistributionFormChange = (e) => {
        setDistributionFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSaveDistribution = async () => {
        const quantita = parseInt(distributionFormData.quantita_da_distribuire, 10);
        if (!quantita || quantita <= 0) {
            alertService.warn("Inserisci una quantità valida."); return;
        }
        if (quantita > selectedMasterVoucher.rimanente) {
            alertService.warn(`Quantità non disponibile. Rimanenti: ${selectedMasterVoucher.rimanente}`); return;
        }

        const payload = {
            id_voucher_superpartner: selectedMasterVoucher.id_voucher_superpartner,
            id_superpartner: selectedAgenzia.id_superpartner,
            id_agenzia_destinataria: selectedAgenzia.id_agenzia,
            quantita_da_distribuire: quantita,
            note: distributionFormData.note
        };
        
        const success = await distributeVoucher(payload);
        if (success) {
            handleCloseDistributeForm();
            loadSuperpartnerVouchers();
        }
    };
/*
// --- FUNZIONE PER LA VISTA DELLO STORICO (FASE 1) ---
    const renderHistoryView = () => (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Voucher già distribuiti a questa agenzia</h6>
                <Button variant="primary" onClick={handleSwitchToDistributeView}>
                    <i className="bi bi-plus-circle me-1"></i> Distribuisci Nuovi Voucher
                </Button>
            </div>
            {isLoading ? <div className="text-center p-3"><Spinner /></div> :
            history.length > 0 ? (
                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th>Corso</th>
                            <th>Quantità</th>
                            <th>Data Distribuzione</th>
                            <th>Scadenza Pacchetto</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((item, index) => (
                            <tr key={index}>
                                <td>{item.nome_corso}</td>
                                <td><Badge bg="info">{item.qt_distribuita}</Badge></td>
                                <td>{UtilityService.formatDate(item.data_distribuzione)}</td>
                                <td>{UtilityService.formatDate(item.data_scadenza)}</td>
                                <td>{item.note || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <Alert variant="secondary">Nessun voucher è stato ancora distribuito a questa agenzia.</Alert>
            )}
        </div>
    );
*/

const renderHistoryView = () => (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Voucher già distribuiti a questa agenzia</h6>
                <Button variant="primary" onClick={handleSwitchToDistributeView}>
                    <i className="bi bi-plus-circle me-1"></i> Distribuisci Nuovi Voucher
                </Button>
            </div>
            {isLoading ? <div className="text-center p-3"><Spinner /></div> :
            history.length > 0 ? (
                // --- MODIFICHE QUI ---
                // 1. Rimuovo 'responsive' e aggiungo stili per controllare il layout
                <Table striped bordered hover size="sm" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <thead className="table-light">
                        <tr>
                            {/* 2. Ottimizzo le larghezze delle colonne */}
                            <th style={{ width: '35%' }}>Corso</th>
                            <th style={{ width: '15%' }}>Quantità</th>
                            <th style={{ width: '20%' }}>Data Distribuzione</th>
                            <th style={{ width: '20%' }}>Scadenza Pacchetto</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((item, index) => (
                            <tr key={index}>
                                {/* 3. Forzo il testo ad andare a capo dove necessario */}
                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.nome_corso}</td>
                                <td><Badge bg="info">{item.qt_distribuita}</Badge></td>
                                <td>{UtilityService.formatDate(item.data_distribuzione)}</td>
                                <td>{UtilityService.formatDate(item.data_scadenza)}</td>
                                <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.note || '-'}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <Alert variant="secondary">Nessun voucher è stato ancora distribuito a questa agenzia.</Alert>
            )}
        </div>
    );
    // --- FUNZIONE PER LA VISTA DI DISTRIBUZIONE (FASE 2) ---
    // Questa è la tua interfaccia a fisarmonica, ora richiamata al momento giusto
    const renderDistributeView = () => (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Seleziona un pacchetto dal tuo magazzino</h6>
                <Button variant="outline-secondary" size="sm" onClick={() => setViewMode('history')}>
                    <i className="bi bi-arrow-left me-1"></i> Torna allo storico
                </Button>
            </div>
            {isLoading ? <div className="text-center p-5"><Spinner /></div> : 
            Object.keys(groupedVouchers).length > 0 ? (
                <Accordion defaultActiveKey="0">
                    {Object.values(groupedVouchers).map((group, index) => (
                        <Accordion.Item eventKey={index.toString()} key={group.nome_corso}>
                            <Accordion.Header>
                                <div className="d-flex justify-content-between w-100 me-2">
                                    <span className="fw-bold">{group.nome_corso}</span>
                                    <Badge bg="success" pill>{group.totale_rimanente} Rimanenti</Badge>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                {group.pacchetti.map(voucher => (
                                    <Card key={voucher.id_voucher_superpartner} className="mb-2">
                                        <Card.Body className="p-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <span className="d-block">Scorta attuale: <strong>{voucher.rimanente}</strong></span>
                                                    <small className="text-muted">Totale pacchetto: {voucher.qt_disponibile}</small>
                                                </div>
                                                <Button variant="primary" size="sm" onClick={() => handleOpenDistributeForm(voucher)} disabled={voucher.rimanente <= 0}>Distribuisci</Button>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            ) : <p className="text-muted text-center mt-4">Nessun pacchetto voucher master da distribuire.</p>}
        </div>
    );

    // --- FUNZIONE "ROUTER" ---
    // Sostituisce la tua vecchia renderBody()
    const renderBody = () => {
        if (viewMode === 'history') {
            return renderHistoryView();
        } else {
            return renderDistributeView();
        }
    };
    
    const renderDistributeFormBody = () => (
        <div>
            <Alert variant="light">
                Stai distribuendo voucher per: <strong>{selectedMasterVoucher?.nome_corso}</strong>.
                <br/>
                Disponibilità massima: <strong>{selectedMasterVoucher?.rimanente}</strong>
            </Alert>
            <Form.Group className="my-3">
                <Form.Label>Quantità da distribuire</Form.Label>
                <Form.Control type="number" name="quantita_da_distribuire" value={distributionFormData.quantita_da_distribuire} onChange={handleDistributionFormChange} max={selectedMasterVoucher?.rimanente} min="1"/>
            </Form.Group>
            <Form.Group className="my-3">
                <Form.Label>Note (opzionale per l'agenzia)</Form.Label>
                <Form.Control as="textarea" rows={2} name="note" value={distributionFormData.note} onChange={handleDistributionFormChange} />
            </Form.Group>
        </div>
    );

    return (
        <>
            <CustomModal
                show={show}
                onHide={onHide}
                headerText="Distribuzione Voucher a Partner"
                body={renderBody()}
                size="lg"
                hideSaveBtn={true}
                onUndoChanges={onHide}
            />
            {selectedMasterVoucher && (
                <CustomModal 
                    show={showDistributeForm} 
                    onHide={handleCloseDistributeForm} 
                    headerText={`Assegna a ${selectedAgenzia.denominazione}`}
                    body={renderDistributeFormBody()} 
                    onSave={handleSaveDistribution} 
                    btnText="Conferma Distribuzione" 
                    isLoading={isDistributing}
                    onUndoChanges={handleCloseDistributeForm}
                />
            )}
        </>
    );
}